import {BASE_URL,GET, GET_ALL_EMAIL} from "../constants";
import { statusParsing, jsonParsing } from "../utils";
import { getAccessToken } from "../../authActions/authActions";

export const fetchEmailVerify = async (email) => {
    const token = await getAccessToken();
    const url = `${BASE_URL}${GET_ALL_EMAIL}${email}`;
    return fetch(url, {
        method: GET,
        headers: {
          "Content-Type": "application/json",
          "userauth" : `bearer ${token}`
        },
      })
      .then(statusParsing)
      .then(jsonParsing);
  };